import { render, staticRenderFns } from "./ProjectsSessions.vue?vue&type=template&id=4adc9ebd&scoped=true"
import script from "./ProjectsSessions.vue?vue&type=script&lang=js"
export * from "./ProjectsSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc9ebd",
  null
  
)

export default component.exports